import { Chip } from '@festo-ui/react';
import ChipContent from '../content/Content';
import useTranslation from '../../../../features/translation/hooks/useTranslation';
import './Container.scss';
import { ChipContainerObject, ChipContainerValue } from '../../../../features/filter/interfaces';

interface ChipContainerProps {
  values: ChipContainerObject;
}
export default function ChipContainer({ values }: ChipContainerProps): JSX.Element {
  const chipsLabels = Object.keys(values);
  const chipsRawContent = Object.values(values);

  const transformContent = (content: ChipContainerValue[]) => {
    const array: string[] = [];
    content.forEach((chip) => {
      switch (typeof chip) {
        case 'boolean':
          array.push(chip ? 'Yes' : 'No');
          break;
        case 'object':
          array.push('No');
          break;
        case 'string':
          array.push(chip);
          break;
        default:
          throw new Error("This shouldn't happen");
      }
    });

    return array;
  };

  const chipsContent = transformContent(chipsRawContent);
  const t = useTranslation();

  return (
    <div className="fwe-chip-container--mobile fwe-chip-container-lg fwe-chip-container fwe-mb-5 fwe-chip--mobile">
      <div className="hide-block hide-transition--left" />
      {chipsLabels.map((filter, index) => (
        <div className={`chip-unit chip-unit--mobile ${index === 0 ? 'mr' : ''}`} key={`${filter} ${index}`}>
          <div className="label">{t(filter)}</div>
          <Chip selected>
            <ChipContent content={chipsContent[index]} />
          </Chip>
        </div>
      ))}
      <div className="hide-block hide-transition--right" />
    </div>
  );
}
